import React  from 'react';
import CurriculumServices from '../services/curriculums-services.js';
import CurriculumStore from '../store/curriculum-store.js';
import Layout from '../components/layouts/standard-page.js';
import Card from '../components/card.js';
import CardBody from '../components/card-body.js';
import CardHeader from '../components/card-header.js';
import {Modal , Media , InputGroup , Badge , Table , ControlLabel , HelpBlock , FormGroup , FormControl , Thumbnail , ListGroup , ListGroupItem ,  Alert , Row , Col , Panel , Button , Navbar , NavDropdown , MenuItem , Nav , NavItem} from 'react-bootstrap';
import CDNImage from '../components/media/image.js';
import LanguageSelector from '../components/inputs/language-selector.js';
import ContentStore from '../store/content-store.js';
import Config from '../classes/config.js';

class ImageUpload extends React.Component {
    constructor(props) {
        super(props);
        this.state = {file: '',imagePreviewUrl: ''};
        this.baseUrl = Config.getBaseUrl();
    }

    _handleSubmit(e) {
        e.preventDefault();
        // TODO: do something with -> this.state.file
        console.log('handle uploading-', this.state.file);
    }

    _handleImageChange(e) {
        e.preventDefault();

        let reader = new FileReader();
        let file = e.target.files[0];

        reader.onloadend = () => {
            this.setState({
                file: file,
                imagePreviewUrl: reader.result
            });
        }

        reader.readAsDataURL(file)
    }

    render() {
        let {imagePreviewUrl} = this.state;
        let $imagePreview = null;
        if (imagePreviewUrl) {
            $imagePreview = (<img className="js--image-preview" src={imagePreviewUrl} />);
        } else {
            $imagePreview = (<div className="js--image-preview"></div>);
        }

        return (
            <div className="previewComponent">
                <div className="box">
                    {$imagePreview}
                </div>
                <span className="btn btn-default btn-block btn-file">
                        Choose Image <input type="file" onChange={(e)=>this._handleImageChange(e)} />
                </span>
            </div>
        )
    }
}

const navbarInstance = (
    <Navbar className="content-menu" collapseOnSelect>
        <Navbar.Header>
            <Navbar.Toggle />
        </Navbar.Header>
        <Navbar.Collapse>
            <Nav>
                <NavItem eventKey={1} href="#">My Modules</NavItem>
                <NavDropdown eventKey={2} title="Module Templates" >
                    <MenuItem eventKey={2.1}>Vocabulary</MenuItem>
                    <MenuItem eventKey={2.2}>Option ONe</MenuItem>
                    <MenuItem divider />
                    <MenuItem eventKey={2.3}>Separated link</MenuItem>
                </NavDropdown>
                <NavDropdown eventKey={3} title="Vocabulary" >
                    <MenuItem eventKey={3.1}>Vocabulary</MenuItem>
                    <MenuItem eventKey={3.2}>Option ONe</MenuItem>
                    <MenuItem divider />
                    <MenuItem eventKey={3.3}><i className="zmdi zmdi-plus-circle"></i>  Create New Vocabulary</MenuItem>
                </NavDropdown>
            </Nav>
            <Nav pullRight>
                <NavItem eventKey={2} href="#"><i className="zmdi zmdi-plus-circle"></i>  Create New Vocabulary</NavItem>
            </Nav>
        </Navbar.Collapse>
    </Navbar>
);

export default class SongsComponent extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {
             store : [],
             name:'',
            learningLanguage:{ietf:null},
             supportLanguage:{ietf:null},
            showModal:false,
        };
    }


    handleChange(e) {
        this.setState({ name: e.target.value });
    }

    handleLearningChange(learningLanguage){
        this.setState({learningLanguage:learningLanguage});
    }

    handelSupportChange(supportLanguage){
        this.setState({supportLanguage:supportLanguage});
    }

    newContent(){

        let warning = null;

        if(this.state.learningLanguage.ietf == this.state.supportLanguage.ietf)
        {
            warning = <Alert bsStyle="warning">
                <strong>Holy guacamole!</strong> This is where the error message if full emersion
            </Alert>
        }

        const jumbotronInstance = (
                <div className="p-20 b-1 ">
                    <Row>
                        <Col md={6}>
                            <FormGroup
                                controlId="formBasicText">
                                <ControlLabel>Module Name</ControlLabel>
                                <FormControl
                                    type="text"
                                    value={this.state.value}
                                    placeholder="Enter text"
                                    onChange={this.handleChange}
                                    />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <FormGroup
                                controlId="formBasicText"
                                >
                                <ControlLabel>Learning Language</ControlLabel>
                                <LanguageSelector onSelect={this.handleLearningChange.bind(this)}/>
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup
                                controlId="formBasicText"
                                >
                                <ControlLabel>Support Language</ControlLabel>
                                <LanguageSelector onSelect={this.handelSupportChange.bind(this)}/>
                            </FormGroup>
                        </Col>
                        <Col md={12}>
                            {warning}
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <Button className="pull-right" bsStyle="primary">Create New Module</Button>
                        </Col>
                    </Row>
                </div>

        );

        return jumbotronInstance;
    }

    toggleVocab(){
        this.setState({showModal:!this.state.showModal});
    }

    renderModuleList(){
        var row = function(){
            return <tr>
                <td width={300}>My Wounderful Sections</td>
                <td>French</td>
                <td>English</td>
                <td width={150}>
                    <Button block>Edit</Button> </td>
                <td width={150}><Button block>Publish</Button> </td>
                <td width={150}><Button block>See Vocabulary</Button> </td>

            </tr>
        };

        return [row(), row() , row()]
    }

    render(){

        let item = <Col md={4}>
                            <Thumbnail className="p-t-20" src={this.baseUrl+"/vocabs/languagenut/module254.png?cacheBreaker=4"} alt="242x200">
                                <ListGroup>
                                    <ListGroupItem>Learning Language 1    <span className="pull-right"><CDNImage size={15} src="img/audioWordPod.png"/></span></ListGroupItem>
                                    <ListGroupItem>Support  Language 2    <span className="pull-right"><CDNImage size={15} src="img/audioWordPod.png"/></span></ListGroupItem>
                                </ListGroup>
                                <br />
                            <Button bsStyle="default" block>Edit</Button>
                            <Button bsStyle="primary" block>Add</Button>
                        </Thumbnail>
                    </Col>;

        let checkoutItems = this.state.store.map(function(items){
            return <ListGroupItem>Vocab 1</ListGroupItem>
        });

        let ffff  = <Media>
            <Media.Left>
                <img className="avatar-img" src={this.baseUrl+"/vocabs/languagenut/module254.png?cacheBreaker=4"} />
            </Media.Left>
            <Media.Right>
                <Media.Heading>Template <Badge>Popular * </Badge></Media.Heading>
                <p>Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin commodo. Cras purus odio, vestibulum in vulputate at, tempus viverra turpis. Fusce condimentum nunc ac nisi vulputate fringilla. Donec lacinia congue felis in faucibus.</p>
                <Button bsStyle="default" block>Add</Button>
                <Button bsStyle="default" block>Preview</Button>
            </Media.Right>
        </Media>

        let Style={display:'table-cell'};
        return (<Layout>

                        <Modal bsSize="large"  show={this.state.showModal} onHide={this.toggleVocab.bind(this)}>
                            <Modal.Header>
                                <Modal.Title>Create Vocab</Modal.Title>
                            </Modal.Header>

                            <Modal.Body>
                                <Row>
                                    <Col md={5}>
                                        <ImageUpload />
                                    </Col>
                                    <Col md={7}>
                                       <div  className="m-t-20 Large-input-height">
                                          <div style={Style} className="p-0 vert-center" md={1}><img className="avatar-img" src="img/flags/fr.png" alt=""/></div>
                                          <div style={Style} className="p-t-25 vert-bottom" md={7}><FormGroup className="fg-line fg-toggled">
                                              <FormControl autoFocus  placeholder="Enter your vocab" type="text" onChange={this.handelClassNameChange}/></FormGroup></div>
                                          <div style={Style} className="p-5 vert-center" md={4}><Button bsStyle="default" block><i className="zmdi-hc-1x zmdi zmdi-volume-up"></i>&nbsp;Play</Button><Button bsStyle="default" block><i className="zmdi-hc-1x zmdi zmdi-mic"></i>&nbsp;Record</Button></div>
                                       </div>
                                        <br />
                                        <div className="m-t-10 Large-input-height">
                                            <div style={Style} className="p-0 vert-center" md={1}><img className="avatar-img" src="img/flags/en.png" alt=""/></div>
                                            <div style={Style} className="p-t-25 vert-bottom" md={7}><FormGroup className="fg-line fg-toggled">
                                                <FormControl autoFocus  placeholder="Enter your vocab" type="text" onChange={this.handelClassNameChange}/></FormGroup></div>
                                            <div style={Style} className="p-5 vert-center" md={4}><Button bsStyle="default" block><i className="zmdi-hc-1x zmdi zmdi-volume-up"></i>&nbsp;Play</Button><Button bsStyle="default" block><i className="zmdi-hc-1x zmdi zmdi-mic"></i>&nbsp;Record</Button></div>

                                        </div>
                                    </Col>
                                </Row>

                            </Modal.Body>

                            <Modal.Footer>
                                <Button bsStyle="danger">Cancel</Button>
                                <Button bsStyle="primary">Save</Button>
                            </Modal.Footer>

                        </Modal>
                       <Row>
                           <Col md={12}>
                               <Card>
                                   {navbarInstance}
                                   <Row collapsible expanded={true} className="p-20">
                                       <Col md={4}>{ffff}</Col>
                                           <Col md={4}>{ffff}</Col>
                                               <Col md={4}>{ffff}</Col>
                                               <Col md={4}>{ffff}</Col>
                                  </Row>
                               </Card>
                           </Col>
                       </Row>
                        <Row>
                            <Col md={9}>
                                <Card>
                                    <CardBody>
                                        <Row>{this.newContent()}</Row>
                                        <Row>
                                            <Col md={12}>
                                                <Table condensed striped responsive bordered>
                                                    <thead>
                                                        <tr>
                                                            <th>Title</th>
                                                            <th>Learning</th>
                                                            <th>Support</th>
                                                            <th colSpan={3}></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                    {this.renderModuleList()}
                                                    </tbody>
                                                </Table>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col md={3}>
                                <Card>
                                    <CardHeader>
                                        <Alert bsStyle="warning">
                                            <strong>Holy guacamole!</strong> This is where the error message should be
                                        </Alert>
                                    </CardHeader>
                                    <CardBody>
                                        <ListGroup>
                                            {checkoutItems}
                                        </ListGroup>
                                        <br />
                                        <br />
                                        <Button block disabled={this.state.store.length === 0}>Save</Button>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                </Layout>);
    }
}


// WEBPACK FOOTER //
// ./src/screens/content-bulider.js